import React from "react";

const RenderToast = (toast, tipo, titulo, detalle, duracion = 7000) => {
  toast?.current?.show({
    severity: tipo,
    summary: titulo,
    detail: detalle,
    life: duracion,
  });
};

export default RenderToast;
